import { ChiptaElement, html } from 'chipta-libs/main.js';
import 'chipta-libs/components/ticketshop-shell.js';
import 'chipta-libs/components/ticketshop-header.js';
import 'chipta-libs/components/login-form.js';
import { layoutStyles } from 'chipta-libs/styles/layout.js';

class LoginPage extends layoutStyles(ChiptaElement) {

  render() {

    return html`

      <ticketshop-shell>
        <ticketshop-header headertext=${gettext('login')}>
          <div class="smaller">
            <login-form></login-form>
          </div>
        </ticketshop-header>
      </ticketshop-shell>

      <style>

        :host {
          display: flex;
          min-height: 100%;
        }

      </style>

    `;

  }

}

customElements.define('login-page', LoginPage);
